/* 0.49.02 - How a table column shows its values: as written, as a
 * number in the platform's number format, or as a date (or date and
 * time) in the platform's date format (Settings > Time & date).
 *
 * col_format[i] is '', 'number', 'date' or 'datetime'. col_number[i]
 * (0.49.01) still means 'number'.
 *
 * shownCell gives the text to show and a sort value: the number, or
 * the moment as milliseconds, so 05.11.2026 sorts after 30.10.2026. A
 * value that is not a number or not an ISO date is shown as it is. */
import { looseNumber } from './looseNumber';
import { readIso } from './dateFormat';
import { formatCalendarDate, formatCalendarDateTime, formatDateOnly, formatDateTime } from '../utils/format';

export const CELL_FORMATS = ['number', 'date', 'datetime'];

export function columnFormats(el) {
  const f = el && Array.isArray(el.col_format) ? el.col_format : [];
  const n = el && Array.isArray(el.col_number) ? el.col_number : [];
  const len = Math.max(f.length, n.length);
  const out = [];
  for (let i = 0; i < len; i += 1) {
    out.push(CELL_FORMATS.includes(f[i]) ? f[i] : (n[i] === true ? 'number' : ''));
  }
  return out.some(Boolean) ? out : null;
}

/* An ISO time with Z or an offset is a moment, shown in the viewer's
   time zone. Without one it is a wall-clock date, shown as written. */
const INSTANT = /T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})$/;

export function shownCell(value, kind, formatNumber) {
  if (!kind || value === null || value === undefined || value === '') return null;
  if (kind === 'number') {
    const n = looseNumber(value);
    if (n === null) return null;
    const f = formatNumber ? formatNumber(n) : null;
    return { text: f == null ? String(n) : String(f), sort: n };
  }
  const s = String(value).trim();
  const v = readIso(s);
  if (!v) return null;
  const instant = INSTANT.test(s);
  const sort = instant ? Date.parse(s) : Date.UTC(v.y, v.m - 1, v.d, v.h, v.mi, v.s);
  const day = `${String(v.y).padStart(4, '0')}-${String(v.m).padStart(2, '0')}-${String(v.d).padStart(2, '0')}`;
  let text;
  if (kind === 'date' || !v.time) {
    text = instant ? formatDateOnly(s) : formatCalendarDate(day);
  } else {
    text = instant ? formatDateTime(s)
      : formatCalendarDateTime(`${day}T${String(v.h).padStart(2, '0')}:${String(v.mi).padStart(2, '0')}`);
  }
  return { text, sort: Number.isFinite(sort) ? sort : null };
}
